export default function QuoteRow({ quote, onDownloadPdf, onDelete }) {
  const totalItems = quote.details?.length ?? 0;

  return (
    <tr>
      <td>
        <span className="badge badge-primary">
          COT-{String(quote.correlativo).padStart(4, "0")}
        </span>
      </td>

      <td>{quote.cliente_nombre ?? "Sin cliente"}</td>

      <td>
        {quote.created_at
          ? new Date(quote.created_at).toLocaleDateString("es-ES", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
          : "—"}
      </td>

      <td style={{ textAlign: "center" }}>{totalItems}</td>

      <td style={{ textAlign: "right" }}>
        $ {Number(quote.total).toFixed(2)}
      </td>

      <td style={{ textAlign: "center" }}>
        {quote.pdf_path ? (
          <button
            className="btn btn-success btn-sm"
            onClick={() => onDownloadPdf(quote)}
            title="Descargar PDF"
          >
            📄 PDF
          </button>
        ) : (
          <span className="badge badge-secondary">No disponible</span>
        )}
      </td>

      <td style={{ textAlign: "center" }}>
        <button
          className="btn btn-danger btn-sm"
          onClick={() => onDelete(quote)}
          title="Eliminar cotización"
        >
          🗑️ Eliminar
        </button>
      </td>
    </tr>
  );
}